import { render, staticRenderFns } from "./ProfilesList.vue?vue&type=template&id=9fe091b4&"
import script from "./ProfilesList.vue?vue&type=script&lang=js&"
export * from "./ProfilesList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/carolinethuelarsen/Documents/development/ibg-screen-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9fe091b4')) {
      api.createRecord('9fe091b4', component.options)
    } else {
      api.reload('9fe091b4', component.options)
    }
    module.hot.accept("./ProfilesList.vue?vue&type=template&id=9fe091b4&", function () {
      api.rerender('9fe091b4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/js/views/overlays/ProfilesList.vue"
export default component.exports